import actionTypes from '../constants/action-types';

const fetchUserPartnerData = () => ({
  type: actionTypes.FETCH_USER_PARTNER_DATA,
});

export default fetchUserPartnerData;
